import { MarketplaceWaitingOverlay } from "./MarketplaceWaitingOverlay";
import { shouldUseEmbeddedMarketplacePayment } from "../utils/embeddedPayment";

interface CheckoutPaymentOverlayProps {
  open: boolean;
  orderId?: number | null;
  /** true enquanto cria o pedido, antes de abrir a janela de pagamento */
  preparing?: boolean;
}

/** Tela escura + loading enquanto aguarda confirmação do pagamento. */
export function CheckoutPaymentOverlay({
  open,
  orderId,
  preparing = false,
}: CheckoutPaymentOverlayProps) {
  const usesEmbeddedPayment = shouldUseEmbeddedMarketplacePayment();
  const title = preparing ? "Preparando pagamento" : "Aguardando pagamento";
  const subtitle = preparing
    ? usesEmbeddedPayment
      ? "Estamos criando seu pedido. A tela de pagamento abrirá em instantes."
      : "Estamos criando seu pedido. A janela de pagamento abrirá em instantes."
    : usesEmbeddedPayment
      ? "Conclua o pagamento na página do dispensador. Use o X para voltar ao Fluxmed."
      : "Conclua o pagamento na janela que abriu. Verificamos o status automaticamente a cada poucos segundos.";

  return (
    <MarketplaceWaitingOverlay
      open={open}
      title={title}
      subtitle={subtitle}
      detail={orderId && !preparing ? `Pedido #${orderId}` : undefined}
    />
  );
}
